/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, type Rest, HttpService } from '@dm/core';
import { type ExtensionFiltering } from 'app/common/types/mo';
import { type Observable } from 'rxjs';

import { type ShareMoTypeE } from './extension-filtering-str.service';

@Injectable({ providedIn: 'root' })
export class ExtensionFilteringService {
    constructor(
        private httpService: HttpService,
    ) { }

    /**
     * 批量查询文件后缀名过滤规则
     */
    getBatchRest(parentId: string, parentType: ShareMoTypeE, vstoreId: string): Rest {
        const rest = this.httpService.makeUrl('extensionFiltering.getBatch');

        rest.setParams({
            PARENTTYPE: parentType,
            vstoreId,
        });
        rest.setFilters([
            { field: 'PARENTID', matchMode: '::', value: parentId },
        ]);

        return rest;
    }

    createExtensionFiltering(params: ExtensionFiltering, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('extensionFiltering.post');
        return this.httpService.post(rest, params, options);
    }

    modifyExtensionFiltering(id: number | string, params: ExtensionFiltering, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('extensionFiltering.put').format(id);
        return this.httpService.put(rest, params, options);
    }

    deleteExtensionFiltering(id: string, vstoreId: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('extensionFiltering.delete')
            .format(id)
            .setParams({ vstoreId });

        return this.httpService.delete(rest, options);
    }
}
